export const processStepLabel = (node, index) => `Step ${index + 1} — ${node.output_name || String(node.instruction || "Untitled step").split(/[.;\n]/)[0].slice(0, 64)}`;
